import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { MdErrorOutline, MdOutlineInfo, MdCheckCircleOutline, MdOutlineWarningAmber, } from 'react-icons/md';
function getAlertClassAndIcon(type) {
    switch (type) {
        case 'error':
            return {
                colorClasses: 'text-red-500 bg-red-100 dark:bg-red-800 dark:text-red-200',
                Icon: MdErrorOutline,
            };
        case 'info':
            return {
                colorClasses: 'text-blue-500 bg-blue-100 dark:bg-blue-800 dark:text-blue-200',
                Icon: MdOutlineInfo,
            };
        case 'success':
            return {
                colorClasses: 'text-green-500 bg-green-100 dark:bg-green-800 dark:text-green-200',
                Icon: MdCheckCircleOutline,
            };
        case 'warning':
            return {
                colorClasses: 'text-orange-500 bg-orange-100 dark:bg-orange-700',
                Icon: MdOutlineWarningAmber,
            };
        default:
            throw new Error(`Unknown status type: ${type}`);
    }
}
function AlertIcon({ className, type }) {
    const { colorClasses, Icon } = getAlertClassAndIcon(type);
    return (_jsx("div", { className: clsx('inline-flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg', colorClasses, className), children: _jsx(Icon, { className: "h-5 w-5" }) }));
}
export { AlertIcon };
//# sourceMappingURL=AlertIcon.js.map